const PROJECT_SLUG = String(process.env.ORY_PROJECT_SLUG);

export default {
  publicBaseUrl: process.env.NEXT_PUBLIC_ORY_API_URL!,
  projectSlug: PROJECT_SLUG,
  sessionCookieName: `ory_session_${PROJECT_SLUG.replace(/-/g, "")}`,
  accessToken: process.env.ORY_ACCESS_TOKEN!,
};
